// @ts-nocheck

import recomputeNextGRBasketStateUtil from '../../../modules/gift-race/utils/recomputeNextGRBasketState';

const recomputeNextMPBasketState = (basketState, action, globalState) =>
  recomputeNextGRBasketStateUtil(basketState, globalState);

export default recomputeNextMPBasketState;
